import {useContext} from "react"
import { CreateEtudeContext } from "./context"

export function useCreateEtudeHook() {
    return useContext(CreateEtudeContext);
}